import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { BASE_URL } from "../../../env";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  accessTypeOptions,
  accessTypeOptionsToString,
} from "../constants/accessTypes";

const AddBranchModal = ({ show, handleClose, fetchBranches }) => {
  const [branchCode, setBranchCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [accessType, setaccessType] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [validationError, setValidationError] = useState("");


  const fetchDivisions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getall/divisions`);
      setDivisions(response.data);
    } catch (error) {
      console.error("Error fetching divisions:", error);
    }
  };

  useEffect(() => {
    fetchDivisions();
  }, []);

  const handleChangeDivision = (selectedOption) => {
    setSelectedDivision(selectedOption);
  };

  const handleChangeAccessType = (selectedOptions) => {
    setaccessType(selectedOptions || []);
  };

  const handleAddBranch = async () => {
    if (!branchCode || !branchName || !selectedDivision || accessType.length === 0) {
      setValidationError("Please Enter All Fields");
      return;
    }
    
    try {
      // Convert selected access types to comma-separated string
      const accessTypeString = accessTypeOptionsToString(accessType);
      
      const response = await axios.post(`${BASE_URL}/api/create/branch`, {
        branchName,
        branchCode,
        divisionId: selectedDivision.value,
        accessType: accessTypeString,
      });

      if (response.data.message) {
        setBranchName("");
        setBranchCode("");
        setSelectedDivision(null);
        setaccessType([]);
        setValidationError("");
        handleClose();
        fetchBranches();
        toast.success("Branch added Successfully");
      } else if (response.data.error) {
        setValidationError("Error: " + response.data.error);
      }
    } catch (error) {
      handleClose();
      setBranchName("");
      setBranchCode("");
      setSelectedDivision(null);
      setaccessType([]);
      setValidationError("");
      toast.error(error.response.data.error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <p className="add-martcategory-title">Add Partner</p>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <p>Division</p>
            <Select
              value={selectedDivision}
              onChange={handleChangeDivision}
              options={divisions.map((division) => ({
                value: division.id,
                label: division.divisionName,
              }))}
              isClearable
              placeholder="---Select Division---"
              className="w-100"
            />
            <p className="mt-2">Partner Code</p>
            <Form.Control
              type="text"
              placeholder="Enter partner Code"
              value={branchCode}
              onChange={(e) => setBranchCode(e.target.value)}
            />
            <p className="mt-2">Partner Name</p>
            <Form.Control
              type="text"
              placeholder="Enter partner Name"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
            />
            <p className="mt-2">Select Access Type</p>
            <Select
              value={accessType}
              onChange={handleChangeAccessType}
              options={accessTypeOptions}
              isMulti
              isClearable
              placeholder="---Select Access Type(s)---"
              className="w-100"
            />
            <h6 className="text-danger">{validationError}</h6>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="bg-danger btn"
            style={{ color: "white" }}
            onClick={handleClose}
          >
            Close
          </button>
          <button className="btn btn-addCredential" onClick={handleAddBranch}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Render ToastContainer */}
      <ToastContainer position="top-center" />
    </>
  );
};

export default AddBranchModal;